import Cookies from 'universal-cookie'
const cookies = new Cookies()

export const PlatformAdminUI = () => {
  try { initPlatformAdminUI() } catch (e) { /* just don't crash old browsers */ }
}

const initPlatformAdminUI = () => {
  document.querySelectorAll('[data-behavior~="platform-admin-quickinfo"]').forEach(quickinfo => {
    initQuickinfo(quickinfo)
  })

  document.querySelectorAll('[data-behavior="highlight-labels-for-testing"]').forEach(highlighter => {
    initLabelHighlighter(highlighter)
  })

  document.querySelectorAll('[data-behavior="toggle-ga-debug-cookie"]').forEach(gaDebugToggler => {
    initGaDebugToggle(gaDebugToggler)
  })

  document.querySelectorAll('[data-behavior="toggle-tailwind-unpurged-cookie"]').forEach(tailwindUnpurgedToggler => {
    initTailwindUnpurgedToggle(tailwindUnpurgedToggler)
  })

  document.querySelectorAll('[data-behavior="write-ga-tracking-path"]').forEach(gaTrackingPathReceiver => {
    writeGaTrackingPath(gaTrackingPathReceiver)
  })

  cookies.get('betterplace_backoffice_user') && initAdminBoxes()
}

const initQuickinfo = (quickinfo) => {
  const collapse = () => quickinfo.classList.toggle('collapsed')

  if (window.innerWidth <= 450) collapse()

  quickinfo.querySelectorAll('[data-behavior="collapse-admin-boxes"]').forEach(toggler => {
    toggler.addEventListener('click', event => {
      event.preventDefault()
      collapse()
    })
  })

  quickinfo.querySelectorAll('[data-behavior="close-admin-boxes"]').forEach(closer => {
    closer.addEventListener('click', event => {
      event.preventDefault()
      document.querySelectorAll('.generic-admin-box.for-platform-admins').forEach(adminBox => {
        adminBox.style.display = 'none'
      })
    })
  })
}

const initLabelHighlighter = (highlighter) => {
  highlighter.addEventListener('click', () => {
    document.querySelectorAll('label').forEach(label => {
      label.classList.toggle('highlight-labels-for-testing')
    })
    highlighter.classList.toggle('bg-purple-600')
  })
}

const initGaDebugToggle = (gaDebugToggler) => {
  if (cookies.get('ga_debug')) {
    gaDebugToggler.classList.add('bg-purple-600')
  }

  gaDebugToggler.addEventListener('click', () => {
    if (cookies.get('ga_debug')) {
      cookies.remove('ga_debug')
    } else {
      const oneHourInSeconds = 3600
      cookies.set('ga_debug', 'true', { maxAge: (oneHourInSeconds * 6) })
    }
    gaDebugToggler.classList.toggle('bg-purple-600')
  })
}

const initTailwindUnpurgedToggle = (tailwindUnpurgedToggler) => {
  if (cookies.get('tailwind_unpurged')) {
    tailwindUnpurgedToggler.classList.add('bg-purple-600')
  }

  tailwindUnpurgedToggler.addEventListener('click', () => {
    if (cookies.get('tailwind_unpurged')) {
      cookies.remove('tailwind_unpurged')
    } else {
      const oneHourInSeconds = 3600
      cookies.set('tailwind_unpurged', 'true', { maxAge: (oneHourInSeconds * 6) })
    }
    window.location.reload()
    tailwindUnpurgedToggler.classList.toggle('bg-purple-600')
  })
}

const writeGaTrackingPath = (gaTrackingPathReceiver) => {
  setInterval(function () {
    gaTrackingPathReceiver.textContent = window.gaTrackingPath
  }, 1000);
}

const initAdminBoxes = () => {
  document.querySelectorAll('[data-permission="admin"]').forEach(async box => {
    box.style.display = '' // Always un-hide the admin box, even if it is not remote
    if (!box.dataset.source) return false // Bail out if we don't have an URL
    const response = await fetch(box.dataset.source)
    if (!response.ok) return false
    box.innerHTML = await response.text()
    box.querySelectorAll('[data-behavior~="platform-admin-quickinfo"]').forEach(quickinfo => {
      initQuickinfo(quickinfo)
    })
  })
}
